import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import { connect } from 'react-redux'

import Navigation from './SpecificationNavigation'
import {
  formattedCategoriesSelector,
} from 'containers/Project/OverviewSidebar/selectors'

const mapStateToProps = (state) => {
  return {
    categories: formattedCategoriesSelector(state),
  }
}

class Sidebar extends Component {
  static propTypes = {
    categories: PropTypes.array.isRequired,
  }

  render() {
    return (
      <Flex auto column>
        <Navigation categories={this.props.categories} containerId='mainContainer'/>
      </Flex>
    )
  }
}

const withConnect = connect(mapStateToProps, null)

export default withConnect(Sidebar)
